module.exports = __webpack_public_path__ + "static/media/AIRTIME.49316ee0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/AIRTIME.svg
// module id = 387
// module chunks = 25